<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <p
        v-if="
          !user.personalInfo ||
            (!user.personalInfo.name && !user.personalInfo.surname)
        "
      >
        {{ user._id }}
      </p>

      <button class="button is-light" slot="trigger" @click.stop v-else>
        {{
          `${user.personalInfo.name || "-"} ${user.personalInfo.surname || "-"}`
        }}
      </button>
    </template>

    <b-dropdown-item
      aria-role="listitem"
      v-if="user.personalInfo && user.personalInfo.socialName"
    >
      <b>{{ $t("common.socialName") }}: </b>
      {{ user.personalInfo.socialName }}
    </b-dropdown-item>

    <b-dropdown-item
      aria-role="listitem"
      v-if="user.personalInfo && user.personalInfo.email"
    >
      <b>{{ $t("accesses.email") }}: </b>
      <a :href="`mailto:${user.personalInfo.email}`" target="_blank">
        {{ user.personalInfo.email }}
      </a>
    </b-dropdown-item>

    <b-dropdown-item
      aria-role="listitem"
      v-if="user.personalInfo && user.personalInfo.cellphone"
    >
      <b>{{ $t("accesses.cell") }}: </b>
      <a
        :href="
          `https://wa.me/${cellphoneWithCountryCallingCode(
            user.personalInfo
          ).replace(/\D/g, '')}`
        "
        target="_blank"
      >
        {{ cellphoneWithCountryCallingCode(user.personalInfo) }}
        <img
          src="../../../assets/img/logo-whatsapp.png"
          alt=""
          style="position: relative; top: 4px; left: 4px;"
        />
      </a>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mask } from "../../../mixins/mask";

export default {
  props: ["user"],

  mixins: [mask]
};
</script>
